/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/// TERMS AND CONDITIONS CHECKBOX IN CART
/*
$(document).ready(function() {
  $('body').on('click', '#agree', function() {
    if ($('#agree').is(':checked')) {
      $("#checkout-ticktock").removeClass("div-disabled");
    }
    else {
      $("#checkout-ticktock").addClass("div-disabled");
    }
  });
});
**/

/** PRODUCT ACCORDION **/

$(function() {$("#accordion").accordion({
  heightStyle: "content",
  collapsible: true,
  active: false,
}); });


/** TIERS **/

$(function () { $('a[href$="exclusive-platinum-tier-items"]').addClass('tier-platinum') });
$(function () { $('a[href$="exclusive-gold-tier-items"]').addClass('tier-gold') });
$(function () { $('a[href$="exclusive-silver-tier-items"]').addClass('tier-silver') });
$(function () { $('a[href$="exclusive-bronze-tier-items"]').addClass('tier-bronze') });


/** INSTAGRAM FEED **/

(function(){
var i, e, d = document, s = "script";i = d.createElement("script");i.async = 1;
i.src = "https://cdn.curator.io/published/42e6a142-5d55-4d76-9698-fd57a5603f7c.js";
e = d.getElementsByTagName(s)[0];e.parentNode.insertBefore(i, e);
})();


/** PO NOTICE **/

// For showing the PO Notice on page load
$(function () {
  if ($('.product-form__inventory').hasClass('inventory--pre-order')) { $('.poNotice').show(); }
  if ( $('.product-form__info-item--stock').hasClass('no-display') ) { $('.poNotice').hide(); }
});

// For showing the PO Notice on variant change
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  if ($('.product-form__inventory').hasClass('inventory--pre-order')) {
    $('.poNotice').show();
    if ( $('.product-form__add-button').text() == "Unavailable" ) { $('.poNotice').hide(); }
    if ( $('.product-form__info-item--stock').hasClass('no-display') ) { $('.poNotice').hide(); }
  } else {
  	$('.poNotice').hide();
  }
});



// If any images are missing, they'll get replaced with this nice image
$("body img").on("error", function() {
  $( this ).attr( "src", "https://cdn.shopify.com/s/files/1/0117/8252/0932/files/missing_352a3862-939a-4e19-a619-c4c38c265bbe.jpg?v=1659455788" );
});